import { IPageableResponse } from "app/global/pagging.dto"
import { IBrandingDto } from "../../settings/branding/branding.dto"

export interface UserGalleryList{
  branding: IBrandingDto
  user_gallery: UserGallery
}

export interface UserGallery extends IPageableResponse<UserGalaryItems> {}

export interface UserGalaryItems {
  id: number
  user_id: number
  workspace_id: number
  image: string
  created_at: string
  updated_at: string
}

export interface Gallery extends Branding{
    id: number;
    image: string,
    image_type?: ImageType
}

export interface Branding {
    id: number;
    image: string,
    image_type?: ImageType
}

export enum ImageType {
    UserImage = 'user_gallery',
    BrandingLogo = 'branding_primary_logo',
    BrandingSecondaryLogo = 'branding_secondary_logo'
}